var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-wiki-user-text.ts
import { subscribeByID } from "@adornis/baseql/operations/mongo.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { AdornisUser } from "@adornis/users/db/a-user.js";
import { customElement, property, state } from "lit/decorators.js";
import { of, switchMap } from "rxjs";
var XWikiUserText = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.userID = new RXController(this, "");
    this._user = new RXController(
      this,
      this.userID.observable.pipe(
        switchMap((id) => {
          if (!id || id === "") {
            return of(null);
          }
          return subscribeByID(AdornisUser, id)({ email: 1 });
        })
      )
    );
  }
  render() {
    return `(${this._user.value?.email ?? "Unbekannter Nutzer"})`;
  }
};
__decorateClass([
  property()
], XWikiUserText.prototype, "userID", 2);
__decorateClass([
  state()
], XWikiUserText.prototype, "_user", 2);
XWikiUserText = __decorateClass([
  customElement("x-wiki-user-text")
], XWikiUserText);
export {
  XWikiUserText
};
